import { render, staticRenderFns } from "./Resource.vue?vue&type=template&id=533e6164&scoped=true"
import script from "./Resource.vue?vue&type=script&lang=js"
export * from "./Resource.vue?vue&type=script&lang=js"
import style0 from "./Resource.vue?vue&type=style&index=0&id=533e6164&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533e6164",
  null
  
)

export default component.exports